import { deleteConfirmationAlert } from "./common";

// date and time picker
window.$("#closeavailability_form #start_date").datetimepicker({
    timepicker: true,
    format: DATE_TIME_FORMAT,
    step: 15,
    dayOfWeekStart: 1,
    minDate: new Date(),
    onShow: function (ct) {
        this.setOptions({
            
        })
    },
    onChangeYear: function (dateText, inst) {
        var date = moment(dateText).format("DD/MM/YYYY HH:mm");
        window.$(inst).val(date);
    },
    onChangeMonth: function (dateText, inst) {
        var date = moment(dateText).format("DD/MM/YYYY HH:mm");
        window.$(inst).val(date);
    }
});
window.$("#closeavailability_form #end_date").datetimepicker({
    timepicker: true,
    format: DATE_TIME_FORMAT,
    step: 15,
    dayOfWeekStart: 1,
    minDate: new Date(),
    onShow: function (ct) {
        this.setOptions({
        })
    },
    onChangeYear: function (dateText, inst) {
        var date = moment(dateText).format("DD/MM/YYYY HH:mm");
        window.$(inst).val(date);
    },
    onChangeMonth: function (dateText, inst) {
        var date = moment(dateText).format("DD/MM/YYYY HH:mm");
        window.$(inst).val(date);
    }
});

function changeDateFormat(d, incflag = false) {
    var date = new Date(d);
    var month = date.getMonth() + 1;
    if (incflag) {
        date.setDate(date.getDate() + 1);
    }
    var day = date.getDate();
    var year = date.getFullYear();
    return year + "/" + month + "/" + day;
}
// exception close time save button click
window.$("#saveExeceptionClosetime").on('click', function () {
    window.$(".error").html('');
    window.toastr.remove();
    window.$('#saveExeceptionClosetime').attr('disabled', 'disabled');
    window.axios({
        method: "post",
        url: window.$("#closeavailability_form").attr('action'),
        data: window.$("#closeavailability_form").serialize() + "&type=close",
    }).then(function (response) {
        window.toastr.success(response.data.message, response.statusText);
        var redirectTo = $("#closeavailability_form").attr('redirectto');
        setTimeout(function () {
            window.location = redirectTo;
        }, 1000);
    }).catch(function (error) {
        window.$('#saveExeceptionClosetime').removeAttr('disabled');
        if (typeof error.response !== 'undefined') {
            if (error.response.status == 400) {
                window.$.each(error.response.data, function (key, value) {
                    window.$('#' + key + '-error').text(value[0]);
                });
            } else if (error.response.status == 500) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            }else if (error.response.status == 409) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            }
        }
    });

});

// data table for exception listing
var table = window.$('.exceptionTable').DataTable({
        "oLanguage": DATATABLE_LANGUAGE_OPTIONS,
    "aLengthMenu": DATATABLE_MENU_LENGTH_OPTIONS,
    "ordering": false,
    "searching": false,
    "info": false,
    processing: true,
    serverSide: true,
    "ajax": {
        "url": window.$(".exceptionTable").attr('link'),
        "type": "GET"
    },
    columns: [
        { data: 'dateRange', name: 'Date Range' },
        { data: 'channel', name: 'Mode' },
        { data: 'reason', name: 'Reason' },
        { data: 'action', name: 'Action', orderable: false, searchable: false }
    ]
});

/**
 * Delete Exception close time
 */
window.$(document).on('click', '.exceptionTable .deleteException', function (e) {
    var currentObj = window.$(this);
    // Call method for delete confirmation
    var promise = deleteConfirmationAlert();
    promise.then(function (result) {
        // If confirmation true, do action for delete
        var myTable = $(".exceptionTable").DataTable({
            bRetrieve: true,
            ajax: window.$(".exceptionTable").attr('link')
        });
        e.preventDefault();
        window.axios({
            method: "DELETE",
            url: currentObj.attr('link')
        })
            .then(function (response) {
                myTable.ajax.reload();
                window.toastr.success(response.data.message, response.statusText);
            })
            .catch(function (error) {
                window.toastr.error(error.response.data.message, error.response.data.statusText);

            });
        return false;

    }).catch(function (err) {
        return false;
    });

});

/*** ALL DAY SCRIPT */
window.addEventListener('DOMContentLoaded', (event) => {
    if($("#exception_all_day").is(':checked')){
        $("#exception_all_day").trigger('change');
    }else{
        $("#exception_all_day").trigger('change');
    }
});
window.$(document).on('change',"#exception_all_day",function(e){
    if($(this).is(':checked')){
        window.$(".datetimepicker").datetimepicker({
            onShow: function (ct) {
                this.setOptions({
                   timepicker:false,
                   format:DATE_FORMAT
                })
            },
        });    
    }else{
        window.$(".datetimepicker").datetimepicker({
            onShow: function (ct) {
                this.setOptions({
                   timepicker:true,
                   format:DATE_TIME_FORMAT
                })
            },
        });
    }
    
});
